import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Studio } from "@/components/site/Studio";
import { Bento } from "@/components/site/Bento";
import { Story } from "@/components/site/Story";
import { Almanac } from "@/components/site/Almanac";
import { Chef } from "@/components/site/Chef";
import { Reviews } from "@/components/site/Reviews";
import { BuySection } from "@/components/site/BuySection";
import { Specs } from "@/components/site/Specs";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <Studio />
      <Bento />
      <Story />
      <Almanac />
      <Chef />
      <BuySection />
      <Reviews />
      <Specs />
      <Footer />
    </main>
  );
}
